export interface BookCafeManualPage {
  title: string;
  image: string;
  width: number;
  height: number;
}

export interface BookCafeManual {
  id: "darts" | "projector" | "arcade";
  title: string;
  description: string;
  pages: BookCafeManualPage[];
}

const imagePath = "/images/hpoint-renewal/book-cafe/manuals";

export const BOOK_CAFE_MANUALS: BookCafeManual[] = [
  {
    id: "darts",
    title: "다트 이용방법",
    description: "게임 시작부터 점수 확인까지",
    pages: [
      { title: "게임 사용 안내", image: `${imagePath}/darts-game.webp`, width: 1055, height: 1491 },
      { title: "점수와 규칙 안내", image: `${imagePath}/darts-score.webp`, width: 1055, height: 1491 },
    ],
  },
  {
    id: "projector",
    title: "빔프로젝터 이용방법",
    description: "리모컨 조작과 영상 시청",
    pages: [
      { title: "리모컨과 영상 시청", image: `${imagePath}/projector.webp`, width: 1254, height: 1254 },
    ],
  },
  {
    id: "arcade",
    title: "오락실 게임 이용방법",
    description: "전원부터 게임 종료까지",
    pages: [
      { title: "전원 켜기", image: `${imagePath}/arcade-power.webp`, width: 1055, height: 1491 },
      { title: "게임 검색", image: `${imagePath}/arcade-search.webp`, width: 1055, height: 1491 },
      { title: "게임 시작", image: `${imagePath}/arcade-start.webp`, width: 1055, height: 1491 },
      { title: "게임 종료", image: `${imagePath}/arcade-exit.webp`, width: 1055, height: 1491 },
    ],
  },
];
